<template>
  <div class="search-input-container"></div>
</template>

<script>
import '@septima/septima-search/src/css/defaultView.css';
import { setupSearch } from '@/septimaSearch';
export default {
  name: 'search-searcher',
  data () {
    return {
      view: null,
      window: {
        width: 0,
        height: 0,
      },
    };
  },
  props: {
    kommunekode: String,
  },
  methods: {
    onSelected (result) {
      this.$emit('result', result);
    },
    onError (error) {
      this.$emit('error', error);
    },
    handleResize () {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
      if (this.view != null && this.view.top() != null) {
        this.view.setMaxHeight(this.window.height - this.view.top() - 40);
      }
    },
  },
  mounted () {
    this.view = setupSearch(this.$el, this.onSelected, this.onError, this.kommunekode, this.$store.state.user.token);
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  destroyed () {
    window.removeEventListener('resize', this.handleResize);
  },
};
</script>

<style lang=scss>
.search-input-container {
 width: 400px;
 position: absolute;
 top: 25px;
 left: 105px;
 z-index: 10;
 border: 1px solid #FFFFFF;
 box-shadow: 0 0 8px 0 rgba(175,186,213,0.30);
}

.search-input-container.ssActive {
  border: 1px solid $default-color;
}
.septimasearch ul.better-autocomplete > li.result.highlight {
  background-color: $default-color-background-light;
  color: $default-color;
}

.septimasearch .ssTargetbit .ssTargetlabel, .septimasearch .ssTargetbit .ssTargetclosebutton {
  background-color: $default-color-dark;
  font-weight: 700;
}
</style>
